// import DateUtils from "@date-io/date-fns";
import 'moment/locale/th'
import {
  getDate,
  getYear,
  getHours,
  getMinutes,
  getSeconds,
  getTime,
  format,
} from 'date-fns'

import {} from 'date-fns/format'
import DateUtils from '@date-io/date-fns'

export default class OverwriteFnsAD extends DateUtils {
  constructor({ locale, formats, instance }) {
    super({ locale, formats, instance })
  }

  format = (date, formatKey) => {
    let newDate = date

    switch (formatKey) {
      case 'year':
        return getYear(newDate)
      case 'dayOfMonth':
        return getDate(newDate)
      case 'monthShort':
        return format(newDate, 'LLLL', { locale: this.locale })
      case 'month':
        return format(newDate, 'LLLL', { locale: this.locale })
      case 'fullDate':
        return format(newDate, 'dd/MM/yyyy', { locale: this.locale })
      case 'monthAndYear':
        return format(newDate, 'LLLL yyyy', { locale: this.locale })
      case 'time':
        return getTime(newDate)
      case 'hours':
        return getHours(newDate)
      case 'minutes':
        return getMinutes(newDate)
      case 'seconds':
        return getSeconds(newDate)
      default:
        return ''
    }
  }
}
